import { css } from '@/styled-system/css';

export const avatarImageStyles = css.raw({
  '&:is(:not(img, svg))': {
    display: 'flex',
    inlineSize: '100%',
    blockSize: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '&:is(img), & img': {
    borderRadius: 'shape.ellipse',
    overflow: 'hidden',
    objectFit: 'cover',
    inlineSize: 'calc(100% - calc(2 * {borderWidths.default}))',
    blockSize: 'calc(100% - calc(2 * {borderWidths.default}))',
  },
});
